<div class="sidebar" [class.open]="isOpen">

  <div class="sidebar-header">
    <div class="logo-container">
      <img src="assets/bg/GSR_Compass_Logo_Horz.png" alt="Green Shield Risk Solutions" class="company-logo"
        [class.collapsed]="!isOpen" />

    </div>
    <div class="app-title" [class.show]="isOpen">
      <span class="title-green">Green Shield</span>
      <span class="title-gray">Compass</span>
    </div>
    <!-- TOGGLE BUTTON -->
    <button class="toggle-btn" (click)="toggleSidebar()" [title]="isOpen ? 'Collapse sidebar' : 'Expand sidebar'">
      <i class="pi" [ngClass]="isOpen ? 'pi-chevron-left' : 'pi-chevron-right'">
      </i>
    </button>
  </div>

<nav class="nav-menu">
  <ng-container *ngFor="let item of visibleItems">


      <ng-container *ngIf="item.children?.length; else simpleItem">
        <div class="nav-item-wrapper"
             (mouseenter)="onItemHover(item, $event)"
             (mouseleave)="onItemLeave()">

          <div class="nav-item"
               [class.has-children]="true"
               [class.active]="isChildActive(item)"
                [class.flyout-open]="hoveredItem === item.label"
               (click)="onNavClick(item)"
               >
            <i [class]="item.icon"></i>
            <span class="nav-label" [class.show]="isOpen">{{ item.label }}</span>
            <i *ngIf="isOpen"
               class="pi chevron-icon"
               [ngClass]="expandedItem === item.label ? 'pi-chevron-up' : 'pi-chevron-down'">
            </i>
          </div>

          <!-- Expanded inline children (sidebar open) -->
          <div class="nav-children" *ngIf="expandedItem === item.label && isOpen">
            <div *ngFor="let child of item.children"
                 class="nav-child-item"
                 [class.active]="commonService.router.url.includes(child.route)"
                 (click)="navigate(child.route)">
              {{ child.label }}
            </div>
          </div>

          <!-- Flyout (sidebar collapsed, hovered) -->
          <div class="nav-flyout"
               *ngIf="!isOpen && hoveredItem === item.label"
               [style.top.px]="flyoutTop"
               [style.left.px]="flyoutLeft"
               (mouseenter)="onFlyoutEnter()"
               (mouseleave)="onFlyoutLeave()">
            <div class="nav-flyout-header">{{ item.label }}</div>
            <div *ngFor="let child of item.children"
                 class="nav-flyout-item"
                 [class.active]="commonService.router.url.includes(child.route)"
                 (click)="navigate(child.route)">
              {{ child.label }}
            </div>
          </div>

        </div>
    </ng-container>

    <!-- Simple item -->
    <ng-template #simpleItem>
      <a class="nav-item"
         [routerLink]="!item.openPopup ? item.route : null"
         routerLinkActive="active"
         [routerLinkActiveOptions]="{ exact: true }"
         (click)="onNavClick(item)"
         [title]="!isOpen ? item.label : ''">
        <i [class]="item.icon"></i>
        <span class="nav-label" [class.show]="isOpen">{{ item.label }}</span>
      </a>
    </ng-template>

  </ng-container>
</nav>

  

<!-- footer -->
<div class="sidebar-bottom">

  <!-- Support & Settings -->
  <div class="sidebar-actions">
    <!-- <div class="action-item"> -->
      <!-- <i class="pi pi-question-circle"></i>
      <span *ngIf="isOpen">Support</span>
    </div> -->

    <div class="action-item" (click)="goToSettings()">
      <i class="pi pi-cog"></i>
      <span *ngIf="isOpen">Settings</span>
    </div>
  <!-- </div> -->

  <!-- Divider -->
  <div class="sidebar-divider"></div>

  <!-- User Profile -->
  <div class="sidebar-user">
    <div class="user-card">
      <div class="user-avatar">{{ profileInitial }}</div>

      <div class="user-info" *ngIf="isOpen">
        <div class="user-name">{{ userName }}</div>
        <div class="user-email">{{ userEmail }}</div>
      </div>

      <div class="user-logout" *ngIf="isOpen" (click)="logout()" title="Logout">
        <i class="pi pi-sign-out"></i>
      </div>
    </div>
  </div>

</div>

</div>